(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[759],{

/***/ 3170:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exercises",
      function () {
        return __webpack_require__(8478);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ExerciseListPage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(3712);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_array_like_to_array.mjs
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_iterable_to_array.mjs
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.4.0_react@18.2.0/node_modules/react-icons/cg/index.esm.js
var index_esm = __webpack_require__(5768);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-indiana-drag-scroll@2.2.0_biqbaboplfbrettd7655fr4n2y/node_modules/react-indiana-drag-scroll/dist/index.es.js

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var n=function(t,e){return(n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)};var o,r,i=(function(t){
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
!function(){var e={}.hasOwnProperty;function n(){for(var t=[],o=0;o<arguments.length;o++){var r=arguments[o];if(r){var i=typeof r;if("string"===i||"number"===i)t.push(r);else if(Array.isArray(r)&&r.length){var s=n.apply(null,r);s&&t.push(s)}else if("object"===i)for(var l in r)e.call(r,l)&&r[l]&&t.push(l)}}return t.join(" ")}t.exports?(n.default=n,t.exports=n):window.classNames=n}()}(r={path:o,exports:{},require:function(t,e){return function(){throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs")}(null==e&&r.path)}},r.exports),r.exports);function s(t,e,n){var o,r,i,s,l;function a(){var c=Date.now()-s;c<e&&c>=0?o=setTimeout(a,e-c):(o=null,n||(l=t.apply(i,r),i=r=null))}null==e&&(e=100);var c=function(){i=this,r=arguments,s=Date.now();var c=n&&!o;return o||(o=setTimeout(a,e)),c&&(l=t.apply(i,r),i=r=null),l};return c.clear=function(){o&&(clearTimeout(o),o=null)},c.flush=function(){o&&(l=t.apply(i,r),i=r=null,clearTimeout(o),o=null)},c}s.debounce=s;var l=s;!function(t,e){void 0===e&&(e={});var n=e.insertAt;if(t&&"undefined"!=typeof document){var o=document.head||document.getElementsByTagName("head")[0],r=document.createElement("style");r.type="text/css","top"===n&&o.firstChild?o.insertBefore(r,o.firstChild):o.appendChild(r),r.styleSheet?r.styleSheet.cssText=t:r.appendChild(document.createTextNode(t))}}(".indiana-scroll-container {\n  overflow: auto; }\n  .indiana-scroll-container--dragging {\n    scroll-behavior: auto !important; }\n    .indiana-scroll-container--dragging > * {\n      pointer-events: none;\n      cursor: -webkit-grab;\n      cursor: grab; }\n  .indiana-scroll-container--hide-scrollbars {\n    overflow: hidden;\n    overflow: -moz-scrollbars-none;\n    -ms-overflow-style: none;\n    scrollbar-width: none; }\n    .indiana-scroll-container--hide-scrollbars::-webkit-scrollbar {\n      display: none !important;\n      height: 0 !important;\n      width: 0 !important;\n      background: transparent !important;\n      -webkit-appearance: none !important; }\n  .indiana-scroll-container--native-scroll {\n    overflow: auto; }\n\n.indiana-dragging {\n  cursor: -webkit-grab;\n  cursor: grab; }\n");var a,c=(a="indiana-scroll-container",function(t,e){if(!t)return a;var n;"string"==typeof t?n=t:e=t;var o=a;return n&&(o+="__"+n),o+(e?Object.keys(e).reduce((function(t,n){var r=e[n];return r&&(t+=" "+("boolean"==typeof r?o+"--"+n:o+"--"+n+"_"+r)),t}),""):"")}),p=function(e){function o(n){var o=e.call(this,n)||this;return o.onEndScroll=function(){o.scrolling=!1,!o.pressed&&o.started&&o.processEnd()},o.onScroll=function(t){var e=o.container.current;e.scrollLeft===o.scrollLeft&&e.scrollTop===o.scrollTop||(o.scrolling=!0,o.processScroll(t),o.onEndScroll())},o.onTouchStart=function(t){var e=o.props.nativeMobileScroll;if(o.isDraggable(t.target))if(o.internal=!0,e&&o.scrolling)o.pressed=!0;else{var n=t.touches[0];o.processClick(t,n.clientX,n.clientY),!e&&o.props.stopPropagation&&t.stopPropagation()}},o.onTouchEnd=function(t){var e=o.props.nativeMobileScroll;o.pressed&&(!o.started||o.scrolling&&e?o.pressed=!1:o.processEnd(),o.forceUpdate())},o.onTouchMove=function(t){var e=o.props.nativeMobileScroll;if(o.pressed&&(!e||!o.isMobile)){var n=t.touches[0];n&&o.processMove(t,n.clientX,n.clientY),t.preventDefault(),o.props.stopPropagation&&t.stopPropagation()}},o.onMouseDown=function(t){o.isDraggable(t.target)&&o.isScrollable()&&(o.internal=!0,-1!==o.props.buttons.indexOf(t.button)&&(o.processClick(t,t.clientX,t.clientY),t.preventDefault(),o.props.stopPropagation&&t.stopPropagation()))},o.onMouseMove=function(t){o.pressed&&(o.processMove(t,t.clientX,t.clientY),t.preventDefault(),o.props.stopPropagation&&t.stopPropagation())},o.onMouseUp=function(t){o.pressed&&(o.started?o.processEnd():(o.internal=!1,o.pressed=!1,o.forceUpdate(),o.props.onClick&&o.props.onClick(t)),t.preventDefault(),o.props.stopPropagation&&t.stopPropagation())},o.container=react.createRef(),o.onEndScroll=l(o.onEndScroll,300),o.scrolling=!1,o.started=!1,o.pressed=!1,o.internal=!1,o.getRef=o.getRef.bind(o),o}return function(t,e){function o(){this.constructor=t}n(t,e),t.prototype=null===e?Object.create(e):(o.prototype=e.prototype,new o)}(o,e),o.prototype.componentDidMount=function(){var t=this.props.nativeMobileScroll,e=this.container.current;window.addEventListener("mouseup",this.onMouseUp),window.addEventListener("mousemove",this.onMouseMove),window.addEventListener("touchmove",this.onTouchMove,{passive:!1}),window.addEventListener("touchend",this.onTouchEnd),e.addEventListener("touchstart",this.onTouchStart,{passive:!1}),e.addEventListener("mousedown",this.onMouseDown,{passive:!1}),t&&(this.isMobile=this.isMobileDevice(),this.isMobile&&this.forceUpdate())},o.prototype.componentWillUnmount=function(){window.removeEventListener("mouseup",this.onMouseUp),window.removeEventListener("mousemove",this.onMouseMove),window.removeEventListener("touchmove",this.onTouchMove),window.removeEventListener("touchend",this.onTouchEnd)},o.prototype.getElement=function(){return this.container.current},o.prototype.isMobileDevice=function(){return void 0!==window.orientation||-1!==navigator.userAgent.indexOf("IEMobile")},o.prototype.isDraggable=function(t){var e=this.props.ignoreElements;if(e){var n=t.closest(e);return null===n||n.contains(this.getElement())}return!0},o.prototype.isScrollable=function(){var t=this.container.current;return t&&(t.scrollWidth>t.clientWidth||t.scrollHeight>t.clientHeight)},o.prototype.processClick=function(t,e,n){var o=this.container.current;this.scrollLeft=o.scrollLeft,this.scrollTop=o.scrollTop,this.clientX=e,this.clientY=n,this.pressed=!0},o.prototype.processStart=function(t){void 0===t&&(t=!0);var e=this.props.onStartScroll;this.started=!0,t&&document.body.classList.add("indiana-dragging"),e&&e({external:!this.internal}),this.forceUpdate()},o.prototype.processScroll=function(t){if(this.started){var e=this.props.onScroll;e&&e({external:!this.internal})}else this.processStart(!1)},o.prototype.processMove=function(t,e,n){var o=this.props,r=o.horizontal,i=o.vertical,s=o.activationDistance,l=o.onScroll,a=this.container.current;this.started?(r&&(a.scrollLeft-=e-this.clientX),i&&(a.scrollTop-=n-this.clientY),l&&l({external:!this.internal}),this.clientX=e,this.clientY=n,this.scrollLeft=a.scrollLeft,this.scrollTop=a.scrollTop):(r&&Math.abs(e-this.clientX)>s||i&&Math.abs(n-this.clientY)>s)&&(this.clientX=e,this.clientY=n,this.processStart())},o.prototype.processEnd=function(){var t=this.props.onEndScroll;this.container.current&&t&&t({external:!this.internal}),this.pressed=!1,this.started=!1,this.scrolling=!1,this.internal=!1,document.body.classList.remove("indiana-dragging"),this.forceUpdate()},o.prototype.getRef=function(t){[this.container,this.props.innerRef].forEach((function(e){e&&("function"==typeof e?e(t):e.current=t)}))},o.prototype.render=function(){var e=this.props,n=e.children,o=e.draggingClassName,r=e.className,s=e.style,l=e.hideScrollbars,a=e.component;return react.createElement(a,{className:i(r,this.pressed&&o,c({dragging:this.pressed,"hide-scrollbars":l,"native-scroll":this.isMobile})),style:s,ref:this.getRef,onScroll:this.onScroll},n)},o.defaultProps={nativeMobileScroll:!0,hideScrollbars:!0,activationDistance:10,vertical:!0,horizontal:!0,stopPropagation:!1,style:{},component:"div",buttons:[0]},o}(react.PureComponent);/* harmony default export */ var index_es = (p);
//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/image.js
var next_image = __webpack_require__(7659);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/link.js
var next_link = __webpack_require__(5968);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(5924);
;// CONCATENATED MODULE: ./components/exercise/ExerciseTag.tsx


function ExerciseTag(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,clsx_m/* default */.Z)(className, "block rounded-xl bg-sky-200 p-1 px-3 text-knut-light-text dark:bg-knut-dark-tag dark:text-knut-dark-text"),
        children: children
    });
};

;// CONCATENATED MODULE: ./components/exercise/ExercisePreview.tsx





function ExercisePreview(param) {
    var image = param.image, name = param.name, slug = param.slug, tags = param.tags;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/exercises/".concat(slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex h-full flex-col rounded-xl bg-knut-light-bg-info transition duration-300 hover:bg-knut-light-bg dark:bg-knut-dark-bg-info hover:dark:bg-knut-dark-bg ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative inline-block aspect-video ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            objectFit: "cover",
                            src: image,
                            width: 320,
                            height: 250,
                            alt: name,
                            className: " rounded-t-md",
                            loading: "lazy"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "px-3 pt-3 font-bold",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-auto py-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-1.5",
                            children: tags === null || tags === void 0 ? void 0 : tags.map(function(t) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExerciseTag, {
                                    className: "mx-1.5 mt-1.5 inline-block",
                                    children: t
                                }, t);
                            })
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./components/layout/PageLayout.tsx + 4 modules
var PageLayout = __webpack_require__(2582);
// EXTERNAL MODULE: ./content/links.ts
var links = __webpack_require__(2304);
// EXTERNAL MODULE: ./content/text.ts
var content_text = __webpack_require__(9862);
;// CONCATENATED MODULE: ./utils/slugify.ts
function slugify(text) {
    var from = "\xe3\xe0\xe1\xe4\xe2ẽ\xe8\xe9\xeb\xea\xec\xed\xef\xee\xf5\xf2\xf3\xf6\xf4\xf9\xfa\xfc\xfb\xf1\xe7\xb7/_,:;";
    var to = "aaaaaeeeeeiiiiooooouuuunc------";
    var newText = text.split("").map(function(letter, i) {
        return letter.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    });
    return newText.toString() // Cast to string
    .toLowerCase() // Convert the string to lowercase letters
    .trim() // Remove whitespace from both sides of a string
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/&/g, "-y-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-"); // Replace multiple - with single -
};

;// CONCATENATED MODULE: ./pages/exercises/index.tsx













var __N_SSG = true;
function ExerciseListPage(param) {
    var exercises = param.exercises;
    var ref = (0,react.useState)(""), searchTerm = ref[0], setSearchTerm = ref[1];
    var ref1 = (0,react.useState)(exercises), filteredExercises = ref1[0], setFilteredExercises = ref1[1];
    var tags = _toConsumableArray(new Set(exercises.flatMap(function(e) {
        return e.tags;
    }).filter(function(x) {
        return typeof x === "string" && x;
    })));
    var ref2 = (0,react.useState)(tags.map(function(e) {
        return {
            tag: e,
            active: false
        };
    })), searchTags = ref2[0], setSearchTags = ref2[1];
    (0,react.useEffect)(function() {
        var e = exercises.filter(filterLogic);
        setFilteredExercises(e);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchTags,
        searchTerm
    ]);
    var filterLogic = function(e) {
        var term = slugify(searchTerm.toLowerCase());
        var name = slugify(e.name.toLowerCase());
        var tags = e.tags;
        var activeTags = searchTags.filter(function(x) {
            return x.active;
        });
        var tagIntersection = activeTags.filter(function(x) {
            return tags.includes(x.tag);
        });
        return name.includes(term) && tagIntersection.length === activeTags.length;
    };
    var clearFilters = function() {
        setSearchTags(searchTags.map(function(x) {
            return _objectSpreadProps((0,_object_spread/* default */.Z)({}, x), {
                active: false
            });
        }));
        setSearchTerm("");
    };
    var og = {
        site_name: content_text/* seo.title */.$K.title,
        title: "Exercises - " + content_text/* seo.title */.$K.title,
        description: "An overview of exercises done during Camp Knut.",
        url: links/* baseUrl */.FH + "/exercises"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
        widthClassName: "max-w-none",
        openGraph: og,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto w-11/12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-3xl font-bold",
                    children: "Exercises"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pb-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex w-full max-w-2xl flex-row items-center gap-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "mt-5 w-full rounded-xl border-2 border-black px-4 py-[6px] text-knut-light-text placeholder:text-slate-400 dark:text-knut-dark-text dark:placeholder:text-slate-500",
                                        type: "text",
                                        value: searchTerm,
                                        placeholder: "zinc exercise",
                                        onChange: function(e) {
                                            setSearchTerm(e.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,clsx_m/* default */.Z)("absolute top-1/2 right-0 -translate-x-1/2 -translate-y-1/2", "mt-2.5 select-none rounded-xl bg-gray-200 p-1 text-black dark:bg-knut-dark-text dark:text-slate-600"),
                                        onClick: clearFilters,
                                        "aria-label": "Clear filters",
                                        title: "Clear filters",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CgClose */.Fk5, {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es, {
                            hideScrollbars: true,
                            nativeMobileScroll: true,
                            className: "flex cursor-grab flex-row gap-4 pt-5 md:order-2",
                            horizontal: true,
                            children: searchTags.sort(function(a, b) {
                                return a.tag.localeCompare(b.tag);
                            }).map(function(e) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)(e.active ? "bg-sky-200 dark:bg-knut-dark-tag" : "bg-gray-200 dark:bg-slate-600", "cursor-pointer select-none rounded-xl py-1 px-3 text-knut-light-text dark:text-knut-dark-text"),
                                    onClick: function() {
                                        setSearchTags(_toConsumableArray(searchTags.filter(function(x) {
                                            return x.tag !== e.tag;
                                        })).concat([
                                            _objectSpreadProps((0,_object_spread/* default */.Z)({}, e), {
                                                active: !e.active
                                            }), 
                                        ]));
                                    },
                                    children: e.tag
                                }, e.tag);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid auto-rows-max gap-4",
                    style: {
                        gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))"
                    },
                    children: filteredExercises.sort(function(a, b) {
                        return a.name.localeCompare(b.name);
                    }).filter(filterLogic).map(function(exercise) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExercisePreview, (0,_object_spread/* default */.Z)({}, exercise), exercise.slug);
                    })
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [154,27,555,131,774,888,179], function() { return __webpack_exec__(3170); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);